export function groupArrayValuesByKeys(array: Record<string, any>[], fields: string[], defaultValue: any = null): Record<string, any[]> {
  return array.reduce((acc, current) => {
    fields.forEach((field) => {
      acc[field] ??= [];
      acc[field].push(current[field] ?? defaultValue);
    });
    return acc;
  }, {});
}